module.exports = __webpack_public_path__ + "static/img/26.a0d1753a.png";